import { render } from "./BasicOptions.vue?vue&type=template&id=ff990d2c"
import script from "./BasicOptions.vue?vue&type=script&lang=ts"
export * from "./BasicOptions.vue?vue&type=script&lang=ts"
script.render = render

export default script